module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap-num"
  }, [_vm._v("Thirteen")]), _vm._v(" "), _c('h3', {
    staticClass: "chap-title"
  }, [_vm._v("Hidden view of the Governor-General")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All that time, Mum was brave and silent. The women who surrounded her wanted to sweep into Government House and storm the doors of the Governor-General.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Governor-General had spent seventeen days burning the crucial papers relating to the governance of a country whose people he did not much like, and seldom saw except as shapes with menacing eyes and too many languages, too many gods, too many leaders. A people who took too little interest in the preservation of their culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He still had twenty-eight days to burn all the secret documents, all the evidence of important negotiations, the notes about dividing up the country, the new map of the nation, the redrawn boundaries, memos about meetings with religious leaders and political figures. He also burnt diary references to the three African women who consoled him while his wife badgered him about the plums of summer and the seashores of Cornwall. The women bore him seven children, whom he denied, though he was to send each of them fifty pounds a year for life, anonymously.-")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And when he heard the story of the marauding women, I saw his eyes light up their green and blue of lovely deep sea fishes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8934b6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/019_Part01Sub01Ch13.vue
// module id = 120
// module chunks = 0